import { render, staticRenderFns } from "./ItsForecastDetail.vue?vue&type=template&id=172c6f42&scoped=true&"
import script from "./ItsForecastDetail.vue?vue&type=script&lang=js&"
export * from "./ItsForecastDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c6f42",
  null
  
)

export default component.exports